import { render, staticRenderFns } from "./editar-pedido.vue?vue&type=template&id=aa9e5be6&scoped=true&"
import script from "./editar-pedido.vue?vue&type=script&lang=ts&"
export * from "./editar-pedido.vue?vue&type=script&lang=ts&"
import style0 from "./editar-pedido.vue?vue&type=style&index=0&id=aa9e5be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9e5be6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VProgressCircular,VRow,VTextField})
